const storyData = [{
  type: 'title',
  id: 1,
  title: {
    alt: '',
    author: '',
    collection_title: 'At the game',
    headline: 'Tiger Blood',
    headline_position: 'over-image-top-left',
    headline_color: '#000',
    published_on: '',
    subhead: 'This Is What the NFL\'s Baddest Rivalry Looks Like',
  },
  video_url: '',
  landscape_images: {
    smallest: {
      url: 'assets/images/steelers-bengals-photos/Header-small.jpg',
      height: '675',
      width: '900'
    },
    small: {
      url: 'assets/images/steelers-bengals-photos/Header-small.jpg',
      height: '675',
      width: '900'
    },
    large: {
      url: 'assets/images/steelers-bengals-photos/Header.jpg',
      height: '1155',
      width: '1539'
    },
    largest: {
      url: 'assets/images/steelers-bengals-photos/Header.jpg',
      height: '1155',
      width: '1539'
    }
  },
  portrait_images: {
    smallest: {
      url: 'assets/images/steelers-bengals-photos/Header-small.jpg',
      height: '675',
      width: '900'
    },
    small: {
      url: 'assets/images/steelers-bengals-photos/Header-small.jpg',
      height: '675',
      width: '900'
    },
    large: {
      url: 'assets/images/steelers-bengals-photos/Header-small.jpg',
      height: '675',
      width: '900'
    },
    largest: {
      url: 'assets/images/steelers-bengals-photos/Header-small.jpg',
      height: '675',
      width: '900'
    }
  },
  clickthrough_url: 'https://ad.doubleclick.net/ddm/clk/310169990;136623905;i',
  ad_title: 'Presented By',
  small_ad_image_url: 'assets/images/sponsor/ford-tile.jpg',
  large_ad_image_url: 'assets/images/sponsor/ford-tile.jpg',
  credit: '',
  share_text: 'Tiger+Blood+%7C+This+Is+What+the+NFL%27s+Baddest+Rivalry+Looks+Like',
  tracking_pixel_url: 'https://ad.doubleclick.net/ddm/ad/N3016.280979.BLEACHERREPORT/B9799701.136623905;sz=1x1;ord=%5Btimestamp%5D;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=',
  twitter_handle: ''
},
{
  id: 2,
  content: '<div class="byline"><h3 class="author">Photography by Benjamin Rasmussen</h3><h3 class="credit">Words by DJ Dunson</h3><h4 class="publish-date">September 20, 2016</h4></p></div>',
  created_at: '2016-09-02T17:56:14.793Z',
  updated_at: '2016-09-05T18:51:38.339Z',
  story_id: 1,
  large_grid_width: 6,
  large_grid_push: 3,
  type: 'long-form',
  index: 1,
},
{
  id: 3,
  content: '<p>Swirl together contempt, inclement weather, raucous diehards, bone-jarring hits, a deep-seated hatred, plus intrusive officiating and you’ve got a typical Pittsburgh Steelers-Cincinnati Bengals divisional battle. Sheer intensity permeates the rivalry. In biblical fashion, heavy rain intensified the bad blood between these two factions.</p><p>January’s AFC wild card clash was riddled in controversy after Cincinnati’s Adam “Pacman” Jones and Vontaze Burfict imploded in the waning moments, setting up Pittsburgh’s game-winning field goal. The melee on the field was matched in the stands; police <a href="http://www.cbssports.com/nfl/news/bengals-steelers-fan-arrests-hitting-a-woman-urination-altercation/" target="_blank">arrested</a> a half-dozen people for a variety of offenses, ranging from fighting to urinating on opposing fans. The Steelers won the game 18-16.</p><p>Sunday’s Week 2 matchup moved an offseason of contentious jaw-jacking into a new year. On this occasion, the Bengals played the role of road marauders seeking to steal a win at Heinz Field, and the fans got to feel like they were right on top of the action.</p>',
  created_at: '2016-09-02T17:56:14.793Z',
  updated_at: '2016-09-05T18:51:38.339Z',
  story_id: 1,
  large_grid_width: 6,
  large_grid_push: 3,
  type: 'long-form',
  index: 1,
},
{
  id: 4,
  created_at: '2016-09-02T17:56:14.793Z',
  updated_at: '2016-09-05T18:51:38.339Z',
  story_id: 1,
  large_image_url: 'https://s3.amazonaws.com/thelab.bleacherreport.com%2Fblitline/a2ebd952-de60-6f94-37c5-3c56c3d7c241-GettyImages-484352988-2048.png',
  credit: '',
  story_item_type: 'image-grid',
  type: 'image-grid',
  title: '',
  index: 2,
  images: [
    {
      id: 1,
      created_at: '2016-09-02T17:56:14.793Z',
      updated_at: '2016-09-05T18:51:38.339Z',
      story_id: 1,
      credit: '',
      story_item_type: 'image',
      index: 1,
      large_grid_width: 6,
      grid_width: 3,
      alt: '',
      type: 'image',
      landscape_images: {
        smallest: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-02a.jpg',
          height: '213',
          width: '320'
        },
        small: {
            url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-02a.jpg',
          height: '400',
          width: '600'
        },
        large: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-02a.jpg',
          height: '683',
          width: '1024'
        },
        largest: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-02a.jpg',
          height: '1366',
          width: '2048'
        }
      },
      portrait_images: {
        smallest: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-02a.jpg',
          height: '213',
          width: '320'
        },
        small: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-02a.jpg',
          height: '400',
          width: '600'
        },
        large: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-02a.jpg',
          height: '683',
          width: '1024'
        },
        largest: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-02a.jpg',
          height: '1366',
          width: '2048'
        }
      }
    },
    {
      id: 2,
      created_at: '2016-09-02T17:56:14.793Z',
      updated_at: '2016-09-05T18:51:38.339Z',
      story_id: 1,
      credit: '',
      story_item_type: 'image',
      index: 2,
      grid_width: 3,
      grid_push: 'gutter',
      large_grid_width: 6,
      large_grid_push: 'gutter',
      alt: '',
      type: 'image',
      landscape_images: {
        smallest: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-02b.jpg',
          height: '213',
          width: '320'
        },
        small: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-02b.jpg',
          height: '400',
          width: '600'
        },
        large: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-02b.jpg',
          height: '683',
          width: '1024'
        },
        largest: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-02b.jpg',
          height: '1366',
          width: '2048'
        }
      },
      portrait_images: {
        smallest: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-02b.jpg',
          height: '213',
          width: '320'
        },
        small: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-02b.jpg',
          height: '400',
          width: '600'
        },
        large: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-02b.jpg',
          height: '683',
          width: '1024'
        },
        largest: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-02b.jpg',
          height: '1366',
          width: '2048'
        }
      }
    }
  ]
},
{
  id: 5,
  content: '<h2>FROM BOYDS TO PACMEN</h2><p>Whether rookie or vet, everybody had a pivotal role to play amid high tensions. Receiver Tyler Boyd played in and around Pittsburgh throughout high school and college but entered Heinz Field as a wide-eyed rookie drafted into the traitor’s camp.</p><p>On the other hand, Jones was a prime instigator in the Bengals’ January playoff collapse, but in Burfict’s absence this time around, Jones and Dre Kirkpatrick were thick as thieves, picking off Roethlisberger one time each.</p>',
  created_at: '2016-09-02T17:56:14.793Z',
  updated_at: '2016-09-05T18:51:38.339Z',
  story_id: 1,
  large_grid_width: 6,
  large_grid_push: 3,
  type: 'long-form',
  index: 1,
},
{
  id: 6,
  created_at: '2016-09-02T17:56:14.793Z',
  updated_at: '2016-09-05T18:51:38.339Z',
  story_id: 1,
  large_image_url: 'https://s3.amazonaws.com/thelab.bleacherreport.com%2Fblitline/a2ebd952-de60-6f94-37c5-3c56c3d7c241-GettyImages-484352988-2048.png',
  credit: '',
  story_item_type: 'image-grid',
  type: 'image-grid',
  title: '',
  index: 3,
  images: [
    {
      id: 2,
      created_at: '2016-09-02T17:56:14.793Z',
      updated_at: '2016-09-05T18:51:38.339Z',
      story_id: 1,
      credit: '',
      story_item_type: 'image',
      index: 2,
      grid_width: 3,
      large_grid_width: 6,
      large_grid_push_gutter: true,
      alt: '',
      type: 'image',
      landscape_images: {
        smallest: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-03b.jpg',
          height: '213',
          width: '320'
        },
        small: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-03b.jpg',
          height: '400',
          width: '600'
        },
        large: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-03b.jpg',
          height: '683',
          width: '1024'
        },
        largest: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-03b.jpg',
          height: '1366',
          width: '2048'
        }
      },
      portrait_images: {
        smallest: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-03b.jpg',
          height: '213',
          width: '320'
        },
        small: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-03b.jpg',
          height: '400',
          width: '600'
        },
        large: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-03b.jpg',
          height: '683',
          width: '1024'
        },
        largest: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-03b.jpg',
          height: '1366',
          width: '2048'
        }
      }
    },
    {
      id: 3,
      created_at: '2016-09-02T17:56:14.793Z',
      updated_at: '2016-09-05T18:51:38.339Z',
      story_id: 1,
      credit: '',
      story_item_type: 'image',
      index: 2,
      grid_width: 3,
      grid_push: 'gutter',
      large_grid_width: 6,
      large_grid_push: 'gutter',
      alt: '',
      type: 'image',
      landscape_images: {
        smallest: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-03c.jpg',
          height: '213',
          width: '320'
        },
        small: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-03c.jpg',
          height: '400',
          width: '600'
        },
        large: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-03c.jpg',
          height: '683',
          width: '1024'
        },
        largest: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-03c.jpg',
          height: '1366',
          width: '2048'
        }
      },
      portrait_images: {
        smallest: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-03c.jpg',
          height: '213',
          width: '320'
        },
        small: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-03c.jpg',
          height: '400',
          width: '600'
        },
        large: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-03c.jpg',
          height: '683',
          width: '1024'
        },
        largest: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-03c.jpg',
          height: '1366',
          width: '2048'
        }
      }
    }
  ]
},
{
  id: 7,
  created_at: '2016-09-02T17:56:14.793Z',
  updated_at: '2016-09-05T18:51:38.339Z',
  story_id: 1,
  credit: '',
  story_item_type: 'image-grid',
  type: 'image-grid',
  title: '',
  index: 2,
  images: [
    {
      id: 1,
      created_at: '2016-09-02T17:56:14.793Z',
      updated_at: '2016-09-05T18:51:38.339Z',
      story_id: 1,
      credit: '',
      story_item_type: 'image',
      index: 1,
      large_grid_width: 'full',
      alt: '',
      type: 'image',
      landscape_images: {
        smallest: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-04_900w.jpg',
          height: '213',
          width: '320'
        },
        small: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-04_900w.jpg',
          height: '400',
          width: '600'
        },
        large: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-04.jpg',
          height: '683',
          width: '1024'
        },
        largest: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-04.jpg',
          height: '1366',
          width: '2048'
        }
      },
      portrait_images: {
        smallest: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-04_900w.jpg',
          height: '213',
          width: '320'
        },
        small: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-04_900w.jpg',
          height: '400',
          width: '600'
        },
        large: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-04_900w.jpg',
          height: '683',
          width: '1024'
        },
        largest: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-04_900w.jpg',
          height: '1366',
          width: '2048'
        }
      }
    }
  ]
},
{
  id: 8,
  clickthrough_url: 'https://ad.doubleclick.net/ddm/clk/310170364;136623262;r',
  created_at: '2016-09-02T17:56:14.793Z',
  updated_at: '2016-09-05T18:51:38.339Z',
  story_id: 1,
  type: 'ad',
  index: 1,
  large_assets: {
    smallest: 'assets/images/sponsor/Fseries_1800x800_2.jpg',
    small: 'assets/images/sponsor/Fseries_1800x800_2.jpg',
    large: 'assets/images/sponsor/Fseries_1800x800_2.jpg',
    largest: 'assets/images/sponsor/Fseries_1800x800_2.jpg',
  },
  small_assets: {
    smallest: 'assets/images/sponsor/Fseries_600x500.jpg',
    small: 'assets/images/sponsor/Fseries_600x500.jpg',
    large: 'assets/images/sponsor/Fseries_600x500.jpg',
    largest: 'assets/images/sponsor/Fseries_600x500.jpg',
  },
  tracking_pixel_url: 'https://ad.doubleclick.net/ddm/ad/N3016.280979.BLEACHERREPORT/B9799701.136623262;sz=1x1;ord=%5Btimestamp%5D;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=',
},
{
  id: 9,
  created_at: '2016-09-02T17:56:14.793Z',
  updated_at: '2016-09-05T18:51:38.339Z',
  story_id: 1,
  credit: '',
  story_item_type: 'image-grid',
  type: 'image-grid',
  title: '',
  index: 2,
  images: [
    {
      id: 1,
      created_at: '2016-09-02T17:56:14.793Z',
      updated_at: '2016-09-05T18:51:38.339Z',
      story_id: 1,
      credit: '',
      story_item_type: 'image',
      index: 1,
      large_grid_width: 6,
      large_grid_push: 3,
      alt: '',
      type: 'image',
      landscape_images: {
        smallest: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-05.jpg',
          height: '213',
          width: '320'
        },
        small: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-05.jpg',
          height: '400',
          width: '600'
        },
        large: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-05.jpg',
          height: '683',
          width: '1024'
        },
        largest: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-05.jpg',
          height: '1366',
          width: '2048'
        }
      },
      portrait_images: {
        smallest: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-05.jpg',
          height: '213',
          width: '320'
        },
        small: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-05.jpg',
          height: '400',
          width: '600'
        },
        large: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-05.jpg',
          height: '683',
          width: '1024'
        },
        largest: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-05.jpg',
          height: '1366',
          width: '2048'
        }
      }
    }
  ]
},
{
  id: 10,
  content: '<h2>THROWING HANDS</h2><p>For the Steelers and Bengals, this rivalry often leads to illegal blows to the head and one or two players getting ejected or heavily penalized.</p><p>Ben Roethlisberger and Andy Dalton were the only ones taking shots Sunday, this time downfield. Giovani Bernard couldn’t get anything going between the tackles, so he became the game’s most productive receiver. Pittsburgh’s DeAngelo Williams matched him yard for yard. Among all the orange stripes and black and yellow, A.J. Green and Antonio Brown usually stand out. In the 94th edition of this rivalry, they blended into the background.</p>',
  created_at: '2016-09-02T17:56:14.793Z',
  updated_at: '2016-09-05T18:51:38.339Z',
  story_id: 1,
  large_grid_width: 6,
  large_grid_push: 3,
  type: 'long-form',
  index: 1,
},
{
  id: 11,
  created_at: '2016-09-02T17:56:14.793Z',
  updated_at: '2016-09-05T18:51:38.339Z',
  story_id: 1,
  large_image_url: 'https://s3.amazonaws.com/thelab.bleacherreport.com%2Fblitline/a2ebd952-de60-6f94-37c5-3c56c3d7c241-GettyImages-484352988-2048.png',
  credit: '',
  story_item_type: 'image-grid',
  type: 'image-grid',
  title: '',
  index: 3,
  images: [
    {
      id: 1,
      created_at: '2016-09-02T17:56:14.793Z',
      updated_at: '2016-09-05T18:51:38.339Z',
      story_id: 1,
      credit: '',
      story_item_type: 'image',
      index: 1,
      grid_width: 3,
      large_grid_width: 4,
      alt: '',
      type: 'image',
      landscape_images: {
        smallest: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-06a.jpg',
          height: '213',
          width: '320'
        },
        small: {
            url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-06a.jpg',
          height: '400',
          width: '600'
        },
        large: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-06a.jpg',
          height: '683',
          width: '1024'
        },
        largest: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-06a.jpg',
          height: '1366',
          width: '2048'
        }
      },
      portrait_images: {
        smallest: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-06a.jpg',
          height: '213',
          width: '320'
        },
        small: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-06a.jpg',
          height: '400',
          width: '600'
        },
        large: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-06a.jpg',
          height: '683',
          width: '1024'
        },
        largest: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-06a.jpg',
          height: '1366',
          width: '2048'
        }
      }
    },
    {
      id: 2,
      created_at: '2016-09-02T17:56:14.793Z',
      updated_at: '2016-09-05T18:51:38.339Z',
      story_id: 1,
      credit: '',
      story_item_type: 'image',
      index: 2,
      grid_width: 3,
      grid_push: 'gutter',
      large_grid_width: 4,
      large_grid_push: 'gutter',
      alt: '',
      type: 'image',
      landscape_images: {
        smallest: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-06b.jpg',
          height: '213',
          width: '320'
        },
        small: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-06b.jpg',
          height: '400',
          width: '600'
        },
        large: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-06b.jpg',
          height: '683',
          width: '1024'
        },
        largest: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-06b.jpg',
          height: '1366',
          width: '2048'
        }
      },
      portrait_images: {
        smallest: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-06b.jpg',
          height: '213',
          width: '320'
        },
        small: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-06b.jpg',
          height: '400',
          width: '600'
        },
        large: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-06b.jpg',
          height: '683',
          width: '1024'
        },
        largest: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-06b.jpg',
          height: '1366',
          width: '2048'
        }
      }
    },
    {
      id: 3,
      created_at: '2016-09-02T17:56:14.793Z',
      updated_at: '2016-09-05T18:51:38.339Z',
      story_id: 1,
      credit: '',
      story_item_type: 'image',
      index: 2,
      large_grid_width: 4,
      large_grid_push: 'gutter',
      alt: '',
      type: 'image',
      landscape_images: {
        smallest: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-06c.jpg',
          height: '213',
          width: '320'
        },
        small: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-06c.jpg',
          height: '400',
          width: '600'
        },
        large: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-06c.jpg',
          height: '683',
          width: '1024'
        },
        largest: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-06c.jpg',
          height: '1366',
          width: '2048'
        }
      },
      portrait_images: {
        smallest: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-06c.jpg',
          height: '213',
          width: '320'
        },
        small: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-06c.jpg',
          height: '400',
          width: '600'
        },
        large: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-06c.jpg',
          height: '683',
          width: '1024'
        },
        largest: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-06c.jpg',
          height: '1366',
          width: '2048'
        }
      }
    }
  ]
},
{
  id: 12,
  created_at: '2016-09-02T17:56:14.793Z',
  updated_at: '2016-09-05T18:51:38.339Z',
  story_id: 1,
  credit: '',
  story_item_type: 'image-grid',
  type: 'image-grid',
  title: '',
  index: 2,
  images: [
    {
      id: 1,
      created_at: '2016-09-02T17:56:14.793Z',
      updated_at: '2016-09-05T18:51:38.339Z',
      story_id: 1,
      credit: '',
      story_item_type: 'image',
      index: 1,
      large_grid_width: 12,
      alt: '',
      type: 'image',
      landscape_images: {
        smallest: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-08_900w.jpg',
          height: '213',
          width: '320'
        },
        small: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-08_900w.jpg',
          height: '400',
          width: '600'
        },
        large: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-08.jpg',
          height: '683',
          width: '1024'
        },
        largest: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-08.jpg',
          height: '1366',
          width: '2048'
        }
      },
      portrait_images: {
        smallest: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-08_900w.jpg',
          height: '213',
          width: '320'
        },
        small: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-08_900w.jpg',
          height: '400',
          width: '600'
        },
        large: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-08_900w.jpg',
          height: '683',
          width: '1024'
        },
        largest: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-08_900w.jpg',
          height: '1366',
          width: '2048'
        }
      }
    }
  ]
},
{
  id: 13,
  content: '<p>If you thought officials were supposed to be the calming force, you thought wrong.  Xavier Grimble’s bobbled touchdown and C.J. Uzomah’s being ruled out of bounds on a touchdown grab clearly had the Bengals defense shook. A slew of controversial calls helped put the frustrated Bengals in an early hole. It wouldn’t be Tiger Blood without a few officials to scream at. It’s a cathartic exercise.</p>',
  created_at: '2016-09-02T17:56:14.793Z',
  updated_at: '2016-09-05T18:51:38.339Z',
  story_id: 1,
  large_grid_width: 6,
  large_grid_push: 3,
  type: 'long-form',
  index: 1,
},
{
  id: 14,
  created_at: '2016-09-02T17:56:14.793Z',
  updated_at: '2016-09-05T18:51:38.339Z',
  story_id: 1,
  credit: '',
  story_item_type: 'image-grid',
  type: 'image-grid',
  title: '',
  index: 2,
  images: [
    {
      id: 1,
      created_at: '2016-09-02T17:56:14.793Z',
      updated_at: '2016-09-05T18:51:38.339Z',
      story_id: 1,
      credit: '',
      story_item_type: 'image',
      index: 1,
      large_grid_width: 8,
      large_grid_push: 2,
      alt: '',
      type: 'image',
      landscape_images: {
        smallest: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-07.jpg',
          height: '213',
          width: '320'
        },
        small: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-07.jpg',
          height: '400',
          width: '600'
        },
        large: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-07.jpg',
          height: '683',
          width: '1024'
        },
        largest: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-07.jpg',
          height: '1366',
          width: '2048'
        }
      },
      portrait_images: {
        smallest: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-07.jpg',
          height: '213',
          width: '320'
        },
        small: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-07.jpg',
          height: '400',
          width: '600'
        },
        large: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-07.jpg',
          height: '683',
          width: '1024'
        },
        largest: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-07.jpg',
          height: '1366',
          width: '2048'
        }
      }
    }
  ]
},
{
  id: 15,
  created_at: '2016-09-02T17:56:14.793Z',
  updated_at: '2016-09-05T18:51:38.339Z',
  story_id: 1,
  large_image_url: 'https://s3.amazonaws.com/thelab.bleacherreport.com%2Fblitline/a2ebd952-de60-6f94-37c5-3c56c3d7c241-GettyImages-484352988-2048.png',
  credit: '',
  story_item_type: 'image-grid',
  type: 'image-grid',
  title: '',
  index: 3,
  images: [
    {
      id: 1,
      created_at: '2016-09-02T17:56:14.793Z',
      updated_at: '2016-09-05T18:51:38.339Z',
      story_id: 1,
      credit: '',
      story_item_type: 'image',
      index: 1,
      grid_width: 3,
      large_grid_width: 6,
      alt: '',
      type: 'image',
      landscape_images: {
        smallest: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-09a.jpg',
          height: '213',
          width: '320'
        },
        small: {
            url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-09a.jpg',
          height: '400',
          width: '600'
        },
        large: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-09a.jpg',
          height: '683',
          width: '1024'
        },
        largest: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-09a.jpg',
          height: '1366',
          width: '2048'
        }
      },
      portrait_images: {
        smallest: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-09a.jpg',
          height: '213',
          width: '320'
        },
        small: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-09a.jpg',
          height: '400',
          width: '600'
        },
        large: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-09a.jpg',
          height: '683',
          width: '1024'
        },
        largest: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-09a.jpg',
          height: '1366',
          width: '2048'
        }
      }
    },
    {
      id: 2,
      created_at: '2016-09-02T17:56:14.793Z',
      updated_at: '2016-09-05T18:51:38.339Z',
      story_id: 1,
      credit: '',
      story_item_type: 'image',
      index: 2,
      grid_width: 3,
      grid_push: 'gutter',
      large_grid_width: 6,
      large_grid_push: 'gutter',
      alt: '',
      type: 'image',
      landscape_images: {
        smallest: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-09b.jpg',
          height: '213',
          width: '320'
        },
        small: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-09b.jpg',
          height: '400',
          width: '600'
        },
        large: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-09b.jpg',
          height: '683',
          width: '1024'
        },
        largest: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-09b.jpg',
          height: '1366',
          width: '2048'
        }
      },
      portrait_images: {
        smallest: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-09b.jpg',
          height: '213',
          width: '320'
        },
        small: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-09b.jpg',
          height: '400',
          width: '600'
        },
        large: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-09b.jpg',
          height: '683',
          width: '1024'
        },
        largest: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-09b.jpg',
          height: '1366',
          width: '2048'
        }
      }
    }
  ]
},
{
  id: 16,
  content: '<h2>BOO THAT MAN</h2><p>Steelers fans let the Bengals hear it. But everyone felt it.</p><p>The rain turned this one into a Tough Mudder. George Iloka and Kirkpatrick had no answer for the Steelers offense without Burfict.</p><p>Burfict put the nasty in Cincinasty; however, Karlos Dansby held his own, racking up 10 tackles.</p>',
  created_at: '2016-09-02T17:56:14.793Z',
  updated_at: '2016-09-05T18:51:38.339Z',
  story_id: 1,
  large_grid_width: 6,
  large_grid_push: 3,
  type: 'long-form',
  index: 1,
},
{
  id: 17,
  created_at: '2016-09-02T17:56:14.793Z',
  updated_at: '2016-09-05T18:51:38.339Z',
  story_id: 1,
  credit: '',
  story_item_type: 'image-grid',
  type: 'image-grid',
  title: '',
  index: 2,
  images: [
    {
      id: 1,
      created_at: '2016-09-02T17:56:14.793Z',
      updated_at: '2016-09-05T18:51:38.339Z',
      story_id: 1,
      credit: '',
      story_item_type: 'image',
      index: 1,
      large_grid_width: 'full',
      alt: '',
      type: 'image',
      landscape_images: {
        smallest: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-10_900w.jpg',
          height: '213',
          width: '320'
        },
        small: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-10_900w.jpg',
          height: '400',
          width: '600'
        },
        large: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-10.jpg',
          height: '683',
          width: '1024'
        },
        largest: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-10.jpg',
          height: '1366',
          width: '2048'
        }
      },
      portrait_images: {
        smallest: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-10_900w.jpg',
          height: '213',
          width: '320'
        },
        small: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-10_900w.jpg',
          height: '400',
          width: '600'
        },
        large: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-10_900w.jpg',
          height: '683',
          width: '1024'
        },
        largest: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-10_900w.jpg',
          height: '1366',
          width: '2048'
        }
      }
    }
  ]
},
{
  id: 18,
  created_at: '2016-09-02T17:56:14.793Z',
  updated_at: '2016-09-05T18:51:38.339Z',
  story_id: 1,
  credit: '',
  story_item_type: 'image-grid',
  type: 'image-grid',
  title: '',
  index: 2,
  images: [
    {
      id: 1,
      created_at: '2016-09-02T17:56:14.793Z',
      updated_at: '2016-09-05T18:51:38.339Z',
      story_id: 1,
      credit: '',
      story_item_type: 'image',
      index: 1,
      large_grid_width: 8,
      large_grid_push: 2,
      alt: '',
      type: 'image',
      landscape_images: {
        smallest: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-11.jpg',
          height: '213',
          width: '320'
        },
        small: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-11.jpg',
          height: '400',
          width: '600'
        },
        large: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-11.jpg',
          height: '683',
          width: '1024'
        },
        largest: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-11.jpg',
          height: '1366',
          width: '2048'
        }
      },
      portrait_images: {
        smallest: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-11.jpg',
          height: '213',
          width: '320'
        },
        small: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-11.jpg',
          height: '400',
          width: '600'
        },
        large: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-11.jpg',
          height: '683',
          width: '1024'
        },
        largest: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-11.jpg',
          height: '1366',
          width: '2048'
        }
      }
    }
  ]
},
{
  id: 19,
  created_at: '2016-09-02T17:56:14.793Z',
  updated_at: '2016-09-05T18:51:38.339Z',
  story_id: 1,
  credit: '',
  story_item_type: 'image-grid',
  type: 'image-grid',
  title: '',
  index: 2,
  images: [
    {
      id: 1,
      created_at: '2016-09-02T17:56:14.793Z',
      updated_at: '2016-09-05T18:51:38.339Z',
      story_id: 1,
      credit: '',
      story_item_type: 'image',
      index: 1,
      large_grid_width: 8,
      large_grid_push: 2,
      alt: '',
      type: 'image',
      landscape_images: {
        smallest: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-12.jpg',
          height: '213',
          width: '320'
        },
        small: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-12.jpg',
          height: '400',
          width: '600'
        },
        large: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-12.jpg',
          height: '683',
          width: '1024'
        },
        largest: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-12.jpg',
          height: '1366',
          width: '2048'
        }
      },
      portrait_images: {
        smallest: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-12.jpg',
          height: '213',
          width: '320'
        },
        small: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-12.jpg',
          height: '400',
          width: '600'
        },
        large: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-12.jpg',
          height: '683',
          width: '1024'
        },
        largest: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-12.jpg',
          height: '1366',
          width: '2048'
        }
      }
    }
  ]
},
{
  id: 20,
  created_at: '2016-09-02T17:56:14.793Z',
  updated_at: '2016-09-05T18:51:38.339Z',
  story_id: 1,
  credit: '',
  story_item_type: 'image-grid',
  type: 'image-grid',
  title: '',
  index: 2,
  images: [
    {
      id: 1,
      created_at: '2016-09-02T17:56:14.793Z',
      updated_at: '2016-09-05T18:51:38.339Z',
      story_id: 1,
      credit: '',
      story_item_type: 'image',
      index: 1,
      large_grid_width: 8,
      large_grid_push: 2,
      alt: '',
      type: 'image',
      landscape_images: {
        smallest: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-13.jpg',
          height: '213',
          width: '320'
        },
        small: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-13.jpg',
          height: '400',
          width: '600'
        },
        large: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-13.jpg',
          height: '683',
          width: '1024'
        },
        largest: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-13.jpg',
          height: '1366',
          width: '2048'
        }
      },
      portrait_images: {
        smallest: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-13.jpg',
          height: '213',
          width: '320'
        },
        small: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-13.jpg',
          height: '400',
          width: '600'
        },
        large: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-13.jpg',
          height: '683',
          width: '1024'
        },
        largest: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-13.jpg',
          height: '1366',
          width: '2048'
        }
      }
    }
  ]
},
{
  id: 21,
  created_at: '2016-09-02T17:56:14.793Z',
  updated_at: '2016-09-05T18:51:38.339Z',
  story_id: 1,
  credit: '',
  story_item_type: 'image-grid',
  type: 'image-grid',
  title: '',
  index: 2,
  images: [
    {
      id: 1,
      created_at: '2016-09-02T17:56:14.793Z',
      updated_at: '2016-09-05T18:51:38.339Z',
      story_id: 1,
      credit: '',
      story_item_type: 'image',
      index: 1,
      large_grid_width: 8,
      large_grid_push: 2,
      alt: '',
      type: 'image',
      landscape_images: {
        smallest: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-14.jpg',
          height: '213',
          width: '320'
        },
        small: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-14.jpg',
          height: '400',
          width: '600'
        },
        large: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-14.jpg',
          height: '683',
          width: '1024'
        },
        largest: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-14.jpg',
          height: '1366',
          width: '2048'
        }
      },
      portrait_images: {
        smallest: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-14.jpg',
          height: '213',
          width: '320'
        },
        small: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-14.jpg',
          height: '400',
          width: '600'
        },
        large: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-14.jpg',
          height: '683',
          width: '1024'
        },
        largest: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-14.jpg',
          height: '1366',
          width: '2048'
        }
      }
    }
  ]
},
{
  id: 22,
  content: '<h2>SWEET AND SOUR</h2><p>The roar of Bengals fans was muted for much of the afternoon until Cincy mounted a comeback. But it wouldn’t be the Bengals if it didn’t come with an additional layer of agony.</p>',
  created_at: '2016-09-02T17:56:14.793Z',
  updated_at: '2016-09-05T18:51:38.339Z',
  story_id: 1,
  large_grid_width: 6,
  large_grid_push: 3,
  type: 'long-form',
  index: 1,
},
{
  id: 23,
  created_at: '2016-09-02T17:56:14.793Z',
  updated_at: '2016-09-05T18:51:38.339Z',
  story_id: 1,
  large_image_url: 'https://s3.amazonaws.com/thelab.bleacherreport.com%2Fblitline/a2ebd952-de60-6f94-37c5-3c56c3d7c241-GettyImages-484352988-2048.png',
  credit: '',
  story_item_type: 'image-grid',
  type: 'image-grid',
  title: '',
  index: 3,
  images: [
    {
      id: 1,
      created_at: '2016-09-02T17:56:14.793Z',
      updated_at: '2016-09-05T18:51:38.339Z',
      story_id: 1,
      credit: '',
      story_item_type: 'image',
      index: 1,
      grid_width: 3,
      large_grid_width: 6,
      alt: '',
      type: 'image',
      landscape_images: {
        smallest: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-15a.jpg',
          height: '213',
          width: '320'
        },
        small: {
            url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-15a.jpg',
          height: '400',
          width: '600'
        },
        large: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-15a.jpg',
          height: '683',
          width: '1024'
        },
        largest: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-15a.jpg',
          height: '1366',
          width: '2048'
        }
      },
      portrait_images: {
        smallest: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-15a.jpg',
          height: '213',
          width: '320'
        },
        small: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-15a.jpg',
          height: '400',
          width: '600'
        },
        large: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-15a.jpg',
          height: '683',
          width: '1024'
        },
        largest: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-15a.jpg',
          height: '1366',
          width: '2048'
        }
      }
    },
    {
      id: 2,
      created_at: '2016-09-02T17:56:14.793Z',
      updated_at: '2016-09-05T18:51:38.339Z',
      story_id: 1,
      credit: '',
      story_item_type: 'image',
      index: 2,
      grid_width: 3,
      grid_push: 'gutter',
      large_grid_width: 6,
      large_grid_push: 'gutter',
      alt: '',
      type: 'image',
      landscape_images: {
        smallest: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-15b.jpg',
          height: '213',
          width: '320'
        },
        small: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-15b.jpg',
          height: '400',
          width: '600'
        },
        large: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-15b.jpg',
          height: '683',
          width: '1024'
        },
        largest: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-15b.jpg',
          height: '1366',
          width: '2048'
        }
      },
      portrait_images: {
        smallest: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-15b.jpg',
          height: '213',
          width: '320'
        },
        small: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-15b.jpg',
          height: '400',
          width: '600'
        },
        large: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-15b.jpg',
          height: '683',
          width: '1024'
        },
        largest: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-15b.jpg',
          height: '1366',
          width: '2048'
        }
      }
    }
  ]
},
{
  id: 245,
  clickthrough_url: 'https://ad.doubleclick.net/ddm/clk/310170364;136623262;r',
  created_at: '2016-09-02T17:56:14.793Z',
  updated_at: '2016-09-05T18:51:38.339Z',
  story_id: 1,
  type: 'ad',
  index: 1,
  large_assets: {
    smallest: 'assets/images/sponsor/Fseries_1800x800_2.jpg',
    small: 'assets/images/sponsor/Fseries_1800x800_2.jpg',
    large: 'assets/images/sponsor/Fseries_1800x800_2.jpg',
    largest: 'assets/images/sponsor/Fseries_1800x800_2.jpg',
  },
  small_assets: {
    smallest: 'assets/images/sponsor/Fseries_600x500.jpg',
    small: 'assets/images/sponsor/Fseries_600x500.jpg',
    large: 'assets/images/sponsor/Fseries_600x500.jpg',
    largest: 'assets/images/sponsor/Fseries_600x500.jpg',
  },
  tracking_pixel_url: 'https://ad.doubleclick.net/ddm/ad/N3016.280979.BLEACHERREPORT/B9799701.136623262;sz=1x1;ord=%5Btimestamp%5D;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=',
},
{
  id: 25,
  created_at: '2016-09-02T17:56:14.793Z',
  updated_at: '2016-09-05T18:51:38.339Z',
  story_id: 1,
  credit: '',
  story_item_type: 'image-grid',
  type: 'image-grid',
  title: '',
  index: 2,
  images: [
    {
      id: 1,
      created_at: '2016-09-02T17:56:14.793Z',
      updated_at: '2016-09-05T18:51:38.339Z',
      story_id: 1,
      credit: '',
      story_item_type: 'image',
      index: 1,
      large_grid_width: 8,
      large_grid_push: 2,
      alt: '',
      type: 'image',
      landscape_images: {
        smallest: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-16.jpg',
          height: '213',
          width: '320'
        },
        small: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-16.jpg',
          height: '400',
          width: '600'
        },
        large: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-16.jpg',
          height: '683',
          width: '1024'
        },
        largest: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-16.jpg',
          height: '1366',
          width: '2048'
        }
      },
      portrait_images: {
        smallest: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-16.jpg',
          height: '213',
          width: '320'
        },
        small: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-16.jpg',
          height: '400',
          width: '600'
        },
        large: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-16.jpg',
          height: '683',
          width: '1024'
        },
        largest: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-16.jpg',
          height: '1366',
          width: '2048'
        }
      }
    }
  ]
},
{
  id: 26,
  content: '<h2>JEREMY HILL’S DEJA VU</h2><p>The end result was all too familiar for Bengals running back Jeremy Hill, whose fumble in the fourth quarter of January\'s playoff loss was the fatal blow. Likewise, Boyd’s fumble put the kibosh on a comeback attempt and reminded the city of Cincinnati that life as a Bengals fan is a repetitive, tragic existence.</p>',
  created_at: '2016-09-02T17:56:14.793Z',
  updated_at: '2016-09-05T18:51:38.339Z',
  story_id: 1,
  large_grid_width: 6,
  large_grid_push: 3,
  type: 'long-form',
  index: 1,
},
{
  id: 27,
  created_at: '2016-09-02T17:56:14.793Z',
  updated_at: '2016-09-05T18:51:38.339Z',
  story_id: 1,
  large_image_url: 'https://s3.amazonaws.com/thelab.bleacherreport.com%2Fblitline/a2ebd952-de60-6f94-37c5-3c56c3d7c241-GettyImages-484352988-2048.png',
  credit: '',
  story_item_type: 'image-grid',
  type: 'image-grid',
  title: '',
  index: 3,
  images: [
    {
      id: 1,
      created_at: '2016-09-02T17:56:14.793Z',
      updated_at: '2016-09-05T18:51:38.339Z',
      story_id: 1,
      credit: '',
      story_item_type: 'image',
      index: 1,
      grid_width: 3,
      large_grid_width: 6,
      alt: '',
      type: 'image',
      landscape_images: {
        smallest: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-17a.jpg',
          height: '213',
          width: '320'
        },
        small: {
            url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-17a.jpg',
          height: '400',
          width: '600'
        },
        large: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-17a.jpg',
          height: '683',
          width: '1024'
        },
        largest: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-17a.jpg',
          height: '1366',
          width: '2048'
        }
      },
      portrait_images: {
        smallest: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-17a.jpg',
          height: '213',
          width: '320'
        },
        small: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-17a.jpg',
          height: '400',
          width: '600'
        },
        large: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-17a.jpg',
          height: '683',
          width: '1024'
        },
        largest: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-17a.jpg',
          height: '1366',
          width: '2048'
        }
      }
    },
    {
      id: 2,
      created_at: '2016-09-02T17:56:14.793Z',
      updated_at: '2016-09-05T18:51:38.339Z',
      story_id: 1,
      credit: '',
      story_item_type: 'image',
      index: 2,
      grid_width: 3,
      grid_push: 'gutter',
      large_grid_width: 6,
      large_grid_push: 'gutter',
      alt: '',
      type: 'image',
      landscape_images: {
        smallest: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-17b.jpg',
          height: '213',
          width: '320'
        },
        small: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-17b.jpg',
          height: '400',
          width: '600'
        },
        large: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-17b.jpg',
          height: '683',
          width: '1024'
        },
        largest: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-17b.jpg',
          height: '1366',
          width: '2048'
        }
      },
      portrait_images: {
        smallest: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-17b.jpg',
          height: '213',
          width: '320'
        },
        small: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-17b.jpg',
          height: '400',
          width: '600'
        },
        large: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-17b.jpg',
          height: '683',
          width: '1024'
        },
        largest: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-17b.jpg',
          height: '1366',
          width: '2048'
        }
      }
    }
  ]
},
{
  id: 28,
  created_at: '2016-09-02T17:56:14.793Z',
  updated_at: '2016-09-05T18:51:38.339Z',
  story_id: 1,
  credit: '',
  story_item_type: 'image-grid',
  type: 'image-grid',
  title: '',
  index: 2,
  images: [
    {
      id: 1,
      created_at: '2016-09-02T17:56:14.793Z',
      updated_at: '2016-09-05T18:51:38.339Z',
      story_id: 1,
      credit: '',
      story_item_type: 'image',
      index: 1,
      large_grid_width: 8,
      large_grid_push: 2,
      alt: '',
      type: 'image',
      landscape_images: {
        smallest: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-18.jpg',
          height: '213',
          width: '320'
        },
        small: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-18.jpg',
          height: '400',
          width: '600'
        },
        large: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-18.jpg',
          height: '683',
          width: '1024'
        },
        largest: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-18.jpg',
          height: '1366',
          width: '2048'
        }
      },
      portrait_images: {
        smallest: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-18.jpg',
          height: '213',
          width: '320'
        },
        small: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-18.jpg',
          height: '400',
          width: '600'
        },
        large: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-18.jpg',
          height: '683',
          width: '1024'
        },
        largest: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-18.jpg',
          height: '1366',
          width: '2048'
        }
      }
    }
  ]
},
{
  id: 29,
  created_at: '2016-09-02T17:56:14.793Z',
  updated_at: '2016-09-05T18:51:38.339Z',
  story_id: 1,
  credit: '',
  story_item_type: 'image-grid',
  type: 'image-grid',
  title: '',
  index: 2,
  images: [
    {
      id: 1,
      created_at: '2016-09-02T17:56:14.793Z',
      updated_at: '2016-09-05T18:51:38.339Z',
      story_id: 1,
      credit: '',
      story_item_type: 'image',
      index: 1,
      large_grid_width: 8,
      large_grid_push: 2,
      alt: '',
      type: 'image',
      landscape_images: {
        smallest: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-19.jpg',
          height: '213',
          width: '320'
        },
        small: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-19.jpg',
          height: '400',
          width: '600'
        },
        large: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-19.jpg',
          height: '683',
          width: '1024'
        },
        largest: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-19.jpg',
          height: '1366',
          width: '2048'
        }
      },
      portrait_images: {
        smallest: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-19.jpg',
          height: '213',
          width: '320'
        },
        small: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-19.jpg',
          height: '400',
          width: '600'
        },
        large: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-19.jpg',
          height: '683',
          width: '1024'
        },
        largest: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-19.jpg',
          height: '1366',
          width: '2048'
        }
      }
    }
  ]
},
{
  id: 30,
  content: '<p>The Steelers are only 2-0, but many fans expressed the type of jubilation usually reserved for watching your lotto numbers being read aloud on live TV.</p>',
  created_at: '2016-09-02T17:56:14.793Z',
  updated_at: '2016-09-05T18:51:38.339Z',
  story_id: 1,
  large_grid_width: 6,
  large_grid_push: 3,
  type: 'long-form',
  index: 1,
},
{
  id: 31,
  created_at: '2016-09-02T17:56:14.793Z',
  updated_at: '2016-09-05T18:51:38.339Z',
  story_id: 1,
  credit: '',
  story_item_type: 'image-grid',
  type: 'image-grid',
  title: '',
  index: 2,
  images: [
    {
      id: 1,
      created_at: '2016-09-02T17:56:14.793Z',
      updated_at: '2016-09-05T18:51:38.339Z',
      story_id: 1,
      credit: '',
      story_item_type: 'image',
      index: 1,
      large_grid_width: 8,
      large_grid_push: 2,
      alt: '',
      type: 'image',
      landscape_images: {
        smallest: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-20.jpg',
          height: '213',
          width: '320'
        },
        small: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-20.jpg',
          height: '400',
          width: '600'
        },
        large: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-20.jpg',
          height: '683',
          width: '1024'
        },
        largest: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-20.jpg',
          height: '1366',
          width: '2048'
        }
      },
      portrait_images: {
        smallest: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-20.jpg',
          height: '213',
          width: '320'
        },
        small: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-20.jpg',
          height: '400',
          width: '600'
        },
        large: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-20.jpg',
          height: '683',
          width: '1024'
        },
        largest: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-20.jpg',
          height: '1366',
          width: '2048'
        }
      }
    }
  ]
},
{
  id: 32,
  content: '<p>"We\'ll see them motherf--kers again. Can\'t wait until we see them again. I take my hat off to Pittsburgh <a href="https://twitter.com/ChrisBurke_SI/status/777607098314227712" target="_blank">today</a>."</p>',
  created_at: '2016-09-02T17:56:14.793Z',
  updated_at: '2016-09-05T18:51:38.339Z',
  story_id: 1,
  large_grid_width: 6,
  large_grid_push: 3,
  type: 'long-form',
  index: 1,
},
{
  id: 33,
  created_at: '2016-09-02T17:56:14.793Z',
  updated_at: '2016-09-05T18:51:38.339Z',
  story_id: 1,
  credit: '',
  story_item_type: 'image-grid',
  type: 'image-grid',
  title: '',
  index: 2,
  images: [
    {
      id: 1,
      created_at: '2016-09-02T17:56:14.793Z',
      updated_at: '2016-09-05T18:51:38.339Z',
      story_id: 1,
      credit: '',
      story_item_type: 'image',
      index: 1,
      large_grid_width: 12,
      alt: '',
      type: 'image',
      landscape_images: {
        smallest: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-21_900w.jpg',
          height: '213',
          width: '320'
        },
        small: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-21_900w.jpg',
          height: '400',
          width: '600'
        },
        large: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-21.jpg',
          height: '683',
          width: '1024'
        },
        largest: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-21.jpg',
          height: '1366',
          width: '2048'
        }
      },
      portrait_images: {
        smallest: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-21_900w.jpg',
          height: '213',
          width: '320'
        },
        small: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-21_900w.jpg',
          height: '400',
          width: '600'
        },
        large: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-21_900w.jpg',
          height: '683',
          width: '1024'
        },
        largest: {
          url: 'assets/images/steelers-bengals-photos/Steelers_Bengals-21_900w.jpg',
          height: '1366',
          width: '2048'
        }
      }
    }
  ]
},
{
  content: {
    stories: [{
      thumbnail_url: 'http://img.bleacherreport.net/cms/media/image/8b/5b/c5/25/0eee/4c47/9785/d203b67cac2b/crop_exact_658522679TB00086_Florida_St.jpg?w=900&h=600&q=50',
      title: 'Francois Caps Off Week of Impressive QB Debuts',
      url: 'http://bleacherreport.com/articles/2661939-in-week-of-impressive-qb-debuts-florida-states-deondre-francois-tops-them-all'
    },
    {
      thumbnail_url: 'http://img.bleacherreport.net/cms/media/image/fc/fd/3f/39/4bd5/4bb7/a443/37af226e3454/crop_exact_GettyImages-457868034.jpg?w=900&h=600&q=50',
      title: 'Disgraced, Discarded: Sark Now Part of Bama Future',
      url: 'http://bleacherreport.com/articles/2661887-disgraced-and-discarded-sarkisian-now-part-of-alabama-future-with-kiffin-saban'
    },
    {
      thumbnail_url: 'http://img.bleacherreport.net/cms/media/image/1f/9b/32/f0/0540/4804/bb83/176e16837186/crop_exact_Indians__2_.jpg?w=900&h=600&q=50',
      title: 'MLB Power Rankings with 4 Weeks to Go',
      url: 'http://bleacherreport.com/articles/2661534-mlb-power-rankings-where-all-30-teams-stand-with-4-weeks-to-go'
    }, {
      thumbnail_url: 'http://img.bleacherreport.net/cms/media/image/ea/a0/28/95/740d/4a0b/9b16/a97079365b56/crop_exact_USATSI_9359269.jpg?w=900&h=600&q=50',
      title: 'Klinsmann Has Chance to Extend Youth Movement',
      url: 'http://bleacherreport.com/articles/2661734-jurgen-klinsmann-has-chance-to-extend-youth-movement-with-changes-on-tuesday'
    }]
  },
  header: 'RELATED CONTENT',
  id: 34,
  index: 9,
  type: 'related-content'
}];

export default storyData;



/** WEBPACK FOOTER **
 ** ./assets/js/data/story-data.js
 **/